/**
 * HubMark is the Hub logo used on the login card.
 *
 * Extracted verbatim from the two LoginPage copies, which carried ~20 lines of
 * identical inline SVG each. The gradient uses a fixed element id, so rendering
 * two of these on one page would collide — it is only ever used once, on the
 * login card, and is not exported from the package for that reason.
 */
export function HubMark() {
  return (
    <svg className="h-14 w-14" viewBox="0 0 56 56" fill="none">
      {/* Outer ring with gradient */}
      <circle cx="28" cy="28" r="24" stroke="url(#hubGradient)" strokeWidth="2" opacity="0.6" />
      {/* Inner ring */}
      <circle
        cx="28"
        cy="28"
        r="16"
        stroke="currentColor"
        strokeWidth="2"
        className="text-coronis-navy-600 dark:text-coronis-blue-500"
      />
      {/* Center hub */}
      <circle
        cx="28"
        cy="28"
        r="6"
        fill="currentColor"
        className="text-coronis-navy-600 dark:text-coronis-blue-500"
      />
      {/* Connection nodes */}
      <circle cx="28" cy="10" r="3" fill="currentColor" className="text-coronis-navy-400 dark:text-coronis-blue-400" />
      <circle cx="28" cy="46" r="3" fill="currentColor" className="text-coronis-navy-400 dark:text-coronis-blue-400" />
      <circle cx="10" cy="28" r="3" fill="currentColor" className="text-coronis-navy-400 dark:text-coronis-blue-400" />
      <circle cx="46" cy="28" r="3" fill="currentColor" className="text-coronis-navy-400 dark:text-coronis-blue-400" />
      {/* Connection lines */}
      <path
        d="M28 16v6M28 34v6M22 28h-6M34 28h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        className="text-coronis-navy-500/70 dark:text-coronis-blue-500/70"
      />
      <defs>
        <linearGradient id="hubGradient" x1="4" y1="4" x2="52" y2="52">
          <stop stopColor="#3b82f6" stopOpacity="0.8" />
          <stop offset="1" stopColor="#3b82f6" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
